function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M.333 26h29.334L15 .667.333 26zm16-4h-2.666v-2.667h2.667V22zm0-5.333h-2.666v-5.334h2.667v5.334z",
  fill: "#FEBD14"
});

var SvgWarningTriangle = function SvgWarningTriangle(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='30' height='26' viewBox='0 0 30 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M0.333496 26.0001H29.6668L15.0002 0.666748L0.333496 26.0001ZM16.3335 22.0001H13.6668V19.3334H16.3335V22.0001ZM16.3335 16.6667H13.6668V11.3334H16.3335V16.6667Z' fill='%23FEBD14'/%3E %3C/svg%3E";
export { SvgWarningTriangle as ReactComponent };